<template>
  <el-dialog v-dialogDrag :title="title" :visible.sync="dlgVisible" :close-on-click-modal="false"
    :close-on-press-escape="false" :append-to-body="true" width="600px">
    <el-form :model="node" label-width="120px" label-position="left" size="small">
      <el-form-item label="节点名称" :rules="[{ required: true }]" :show-message="false">
        <el-input v-model="node.nodeName" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="处理人" :rules="[{ required: true }]" :show-message="false">
        <userList ref="userList" v-model="assigneeList" :can-edit="true" />
        <div class="tip"><i class="el-icon-info"></i>节点有多个处理人时，需要每个人都通过，节点才能完成</div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="default" size="small" @click="dlgVisible = false">取消</el-button>
      <el-button type="primary" size="small" @click="handleSubmit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { arrayNotEmpty, notBlank } from '@/CommonDP/utils/validate';
import userList from './userList.vue';
import flowService from '@/CommonDP/service/flow-service';

export default {
  components: { userList },
  props: {
    flowInstanceId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      dlgVisible: false,
      title: "添加节点(加签)",
      addMode: true,
      node: {
        nodeName: ""
      },
      assigneeList: []
    };
  },

  methods: {
    showAdd() {
      this.addMode = true;
      this.title = "添加节点(加签)";
      this.dlgVisible = true;
    },

    showEdit(node) {
      this.node = node;
      this.addMode = false;
      this.title = "修改节点(加签)";
      this.dlgVisible = true;
    },

    async handleSubmit() {
      console.debug(this.assigneeList);
      const success = notBlank(this.node.nodeName, "节点名称不能为空") &&
                      arrayNotEmpty(this.assigneeList, "请选择至少一个审批人/处理人") &&
                      notBlank(this.flowInstanceId, "所属节点编号不能为空");
      if (!success) {
        return;
      }
      const json = {
        lastFlowInstanceNodeId: this.flowInstanceId,
        nodeName: this.node.nodeName,
        assigneeList: this.assigneeList
      };
      await flowService.addTempNode(json);
      this.$success("操作成功");
      this.dlgVisible = false;
      this.$emit("ok");
    }
  }

};
</script>

<style lang="scss" scoped>
.top {
  // color: gray;
  color: lightgray;
}
</style>
